const
  OR        = 'OR',
  SEMICOLON = encodeURIComponent(';'),
  BRACKETS  = encodeURIComponent('[]'),
  ACTIVE    = 'active'
;

const {$, _} = Voonto;

class ArchiveView {
  constructor(container$) {
    this.container$      = container$;
    this.inputAll$       = container$.find('input[data-voc-krammer-archive-all-words]');
    this.inputPhrase$    = container$.find('input[data-voc-krammer-archive-exact-phrase]');
    this.inputAny$       = container$.find('input[data-voc-krammer-archive-any-words]');
    this.inputWithout$   = container$.find('input[data-voc-krammer-archive-without-words]');
    this.dayCheckbox$    = container$.find('input[data-voc-krammer-archive-day]');
    this.periodCheckbox$ = container$.find('input[data-voc-krammer-archive-period]');
    this.submit$         = container$.find('input[data-voc-krammer-archive-submit]');
    this.startsAtDay$    = container$.find('input[data-voc-krammer-archive-startsat-day]');
    this.startsAtMonth$  = container$.find('input[data-voc-krammer-archive-startsat-month]');
    this.startsAtYear$   = container$.find('input[data-voc-krammer-archive-startsat-year]');
    this.endsAtDay$      = container$.find('input[data-voc-krammer-archive-endsat-day]');
    this.endsAtMonth$    = container$.find('input[data-voc-krammer-archive-endsat-month]');
    this.endsAtYear$     = container$.find('input[data-voc-krammer-archive-endsat-year]');
    this.sectionFilters$ = container$.find('[data-voc-krammer-archive-section-filter]');
    this.formatFilters$  = container$.find('[data-voc-krammer-archive-format-filter]');

    this.bindEvents();
  }

  bindEvents() {
    this.container$.on('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
      if(!this.checkConstraints()) {
          event.preventDefault();

          return false;
      }

      return this.buildFormAction();
  }

  checkConstraints() {
    var rules = [ this.atLeastOneTextCriteriaIsMandatory() ];
    var result = true;

    rules.forEach((rule) => {
        if(!rule.isSatisfied) {
            this.container$.find(`[${rule.attribute}]`).text(rule.message);
            this.container$.trigger("invalid", [rule]);
            result = false;
        }
    });

    return result;
  }

  atLeastOneTextCriteriaIsMandatory() {
    return {
        'message': 'Al menos un criterio de texto es obligatorio.',
        'attribute': 'voc-krammer-archive-at-least-one-criteria-is-mandatory',
        'isSatisfied': (
        [this.inputAll$, this.inputPhrase$, this.inputAny$, this.inputWithout$].map(
            (element) => {
                return $(element).val();
            }).join("").length > 0)
    };
  }

  buildFormAction() {
    var all, phrase, any, without, date, action, sections = [], formats = [], base;

    [all, phrase, any, without] = [
      $.trim(this.inputAll$.val()),
      `"${$.trim(this.inputPhrase$.val())}"`,
      $.trim(this.inputAny$.val()).split(' ').join(` ${OR} `),
      $.trim(this.inputWithout$.val()).split(' ').map((word) => {
        return `-${word}`;
      }).join(' ')
    ];

    action = [];
    !_.isEmpty(all) && action.push(all);
    phrase !== `""` && action.push(phrase);
    !_.isEmpty(any) && action.push(any);
    without !== '-' && action.push(without);

    if (this.dayCheckbox$.is(':checked')) {
      date = `date=${this.startsAtYear$.val()}${_formatDate(this.startsAtMonth$.val())}${_formatDate(this.startsAtDay$.val())}`;
    } else {
      date = `date=${this.startsAtYear$.val()}${_formatDate(this.startsAtMonth$.val())}${_formatDate(this.startsAtDay$.val())}`;
      date += `${SEMICOLON}${this.endsAtYear$.val()}${_formatDate(this.endsAtMonth$.val())}${_formatDate(this.endsAtDay$.val())}`;
    }

    this.sectionFilters$.each(function() {
      const item$ = $(this);
      if (item$.hasClass(ACTIVE)) {sections.push(`section${BRACKETS}=${item$.data('voc-krammer-archive-section-filter')}`);}
    });

    this.formatFilters$.each(function() {
      const item$ = $(this);
      if (item$.hasClass(ACTIVE)) {formats.push(`format${BRACKETS}=${item$.data('voc-krammer-archive-format-filter')}`);}
    });

    action = `${encodeURIComponent(action.join(' '))}.html`;
    action += `?${date}&${sections.concat(formats).join('&')}`;
    base = this.container$.attr('action') || '';

    document.location.href = `${base}${action}`;

    return false;
  }
}

export default ArchiveView;

/* Private */

function _formatDate(d) {
  if (d < 10 && d.length === 1) {d = `0${d}`;}
  return d;
}




// WEBPACK FOOTER //
// ./src/views/archive.js